const $ = jQuery;

Drupal.behaviors.textarea_field = {
attach: function (context, settings) {
        $('textarea', context).each(function () {
            this.setAttribute('style', 'height:' + (this.scrollHeight) + 'px;overflow-y:hidden;');
        }).on('input', function () {
            this.style.height = 'auto';
            this.style.height = (this.scrollHeight) + 'px';
        });
    },
};
